import * as React from 'react';
import {Component} from 'react';
import {Title, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {getBreadCrumbsProps} from '../../utils/HeaderUtils';
import {getQaMode} from '../../../../_shared/GWTBridge/invoke/common';
import {featurePopoverRef} from '../../../../features/FeaturePopover/FeaturePopover.root';
import {featuresIDs} from '../../../../features/FeaturePopover/constants/map';
import {
    getCompanyCountryByDname,
    isCurrentEntBPM,
    shouldShowAILabel
} from '../../../../_shared/GWTBridge/invoke/genPage';
import {BreadCrumbsList, Breadcrumb as ReactBreadcrumb} from '../../../../features/Form/types';
import {navigateBackFromOldUi} from '../../../../_shared/GWTBridge/invoke/netForm';
import {isRTL} from '../../../../Localization';
import {texts} from '../../../../features/Automations/modules/BPMRules/texts';
import {ModernTooltip} from '../../../../components/Common/Tooltip/ModernTooltip';
import {
    setIsraelTaxRegulationUpdateCookie,
    setIsraelTaxRegulationUpdateLocalStorage,
    shouldShowIsraelTaxRegulationUpdateFeature
} from '../../../../features/FeaturePopover/actions/feature';
import {TODOLIST} from '../../../../features/ToDoList/consts';
import {WWWDBTODOLIST} from '../../../../features/Homepage/constants';
import {homepageStore} from '../../../../features/Homepage/store/HomepageStore';
import aiERPlabel from '../../../../images/aiERPlabel.svg';

interface BreadCrumbsProps {
    breadCrumbs: Array<BreadCrumb>;
    procTitle?: string;
    procTitleType?: string;
    procTitleClick?: () => void;
    formName?: string;
    reactBreadCrumbs?: BreadCrumbsList;
    formSession?: string;
}

interface BreadCrumb {
    title: string;
    menuButton: any; // Menu button object which we recieve form GWT
    handleBreadCrumbClick: (event, menuButton) => void;
    ename: string;
}

interface BreadCrumbsState {
    width: number;
}

class BreadCrumbs extends Component<BreadCrumbsProps, BreadCrumbsState> {
    resizeTimer;

    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    headerTitleRef = React.createRef<HTMLDivElement>();
    exportInvoiceEOLSession = null;
    israelTaxRegulationUpdateSession = null;

    updateDimensions() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
            if (window.innerWidth < 500) {
                this.setState({width: 450});
            } else {
                const update_width = window.innerWidth;
                this.setState({width: update_width});
            }
        }, 250);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions.bind(this));
        const currentCountry = getCompanyCountryByDname();
        if (
            currentCountry !== 'ISR' &&
            currentCountry !== '' &&
            this.headerTitleRef?.current &&
            this.props.formName === 'FINVOICES'
        ) {
            this.exportInvoiceEOLSession = this.props.formSession;
            featurePopoverRef?.current?.showFeaturePopover(
                featuresIDs.exportInvoiceEOL,
                this.headerTitleRef?.current
            );
        }
        if (
            currentCountry === 'ISR' &&
            this.headerTitleRef?.current &&
            shouldShowIsraelTaxRegulationUpdateFeature(this.props.formName)
        ) {
            this.israelTaxRegulationUpdateSession = this.props.formSession;
            setIsraelTaxRegulationUpdateCookie();
            featurePopoverRef?.current?.showFeaturePopover(
                featuresIDs.israelTaxRegulationUpdate,
                this.headerTitleRef?.current,
                setIsraelTaxRegulationUpdateLocalStorage
            );
        }
        if (this.props.formName === TODOLIST) {
            this.showToDoListFeaturePromo();
        }
    }

    componentDidUpdate() {
        const currentCountry = getCompanyCountryByDname();
        if (
            currentCountry !== 'ISR' &&
            currentCountry !== '' &&
            this.headerTitleRef?.current &&
            this.props.formName === 'FINVOICES' &&
            this.exportInvoiceEOLSession !== this.props.formSession
        ) {
            this.exportInvoiceEOLSession = this.props.formSession;
            featurePopoverRef?.current?.showFeaturePopover(
                featuresIDs.exportInvoiceEOL,
                this.headerTitleRef?.current
            );
        }
        if (
            currentCountry === 'ISR' &&
            this.headerTitleRef?.current &&
            shouldShowIsraelTaxRegulationUpdateFeature(this.props.formName) &&
            this.israelTaxRegulationUpdateSession !== this.props.formSession
        ) {
            this.israelTaxRegulationUpdateSession = this.props.formSession;
            setIsraelTaxRegulationUpdateCookie();
            featurePopoverRef?.current?.showFeaturePopover(
                featuresIDs.israelTaxRegulationUpdate,
                this.headerTitleRef?.current,
                setIsraelTaxRegulationUpdateLocalStorage
            );
        }
        if (this.props.formName === TODOLIST) {
            this.showToDoListFeaturePromo();
        }
    }

    showToDoListFeaturePromo() {
        const isWidgetOnHomepage = !!homepageStore?.groups
            ?.get('insights')
            ?.items?.find(item => item.ename === WWWDBTODOLIST);

        if (isWidgetOnHomepage) {
            return;
        } else {
            featurePopoverRef?.current?.showFeaturePopover(
                featuresIDs.toDoListWidget,
                this.headerTitleRef?.current
            );
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions.bind(this));
    }

    renderBreadCrumbSeparator() {
        return (
            <Icon
                icon={isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight}
                iconColor="secondary-400"
                componentClasses="crumbs-separator"
            />
        );
    }

    render() {
        const {
            breadCrumbs = [],
            reactBreadCrumbs = [],
            procTitle,
            procTitleType,
            formName,
            procTitleClick
        } = this.props;
        // Merge reactBreadCrumbs and breadCrumbs, prioritizing ReactBreadcrumb for duplicate enames
        const mergedBreadCrumbs: (ReactBreadcrumb | BreadCrumb)[] = [...reactBreadCrumbs];
        const reactEnameSet = new Set(reactBreadCrumbs.map(item => item.ename));

        // Add breadCrumbs that don't have matching enames in reactBreadCrumbs
        breadCrumbs.forEach(breadCrumb => {
            if (!reactEnameSet.has(breadCrumb.ename)) {
                mergedBreadCrumbs.push(breadCrumb);
            }
        });

        const allBreadCrumbs = mergedBreadCrumbs;
        if (allBreadCrumbs.length === 0) {
            return null;
        }

        let {pixelToLetterRatio, currentWidth, breadCrumbsWidth, breadCrumbsLength} =
            getBreadCrumbsProps(allBreadCrumbs);
        const maxWidth = this.state.width / 2;

        const renderProcIconByType = procTitleType => {
            switch (procTitleType) {
                case 'H':
                    return (
                        <Icon
                            icon={PriorityIcon.newReport}
                            componentClasses="breadcrumbs-icon breadcrumbs-doc-icon"
                        />
                    );
                case 'R':
                    return (
                        <Icon
                            icon={PriorityIcon.rNew}
                            componentClasses="breadcrumbs-icon breadcrumbs-report-icon"
                        />
                    );
                case 'P':
                default:
                    return (
                        <Icon
                            icon={PriorityIcon.dNew}
                            componentClasses="breadcrumbs-icon breadcrumbs-proc-icon"
                        />
                    );
            }
        };

        const isBreak = breadCrumbsWidth > maxWidth;

        const isNewApiBreadcrumb = (obj: BreadCrumb | ReactBreadcrumb) => {
            return 'title' in obj && 'ename' in obj && 'level' in obj && 'session' in obj;
        };

        const onBreadcrumbClick = (e, item: BreadCrumb | ReactBreadcrumb) => {
            if (isNewApiBreadcrumb(item)) {
                const castedItem = item as ReactBreadcrumb;
                navigateBackFromOldUi(castedItem.level, castedItem.session);
            } else {
                const castedItem = item as BreadCrumb;
                castedItem.handleBreadCrumbClick(e, castedItem.menuButton);
            }
        };

        /*
            Breadcrumbs component accupy maxumim half of the screen width.
            We need to claculate if there is a need to "break" the breadcrumbs and show "...".
            We always show the first crumb.
            If we do break, we will show the last 2 crumbs and everything before them as long as we have space.
        */

        return (
            <section className="bread-crumbs">
                {procTitleType && (
                    <div className="crumb-container">
                        {renderProcIconByType(procTitleType)}
                        <span className="bread-crumb" onClick={procTitleClick}>
                            <span>{procTitle}</span>
                        </span>
                        {this.renderBreadCrumbSeparator()}
                    </div>
                )}
                {isCurrentEntBPM() ? (
                    <div ref={this.headerTitleRef} anchor-id="form_header_title">
                        <Title skin="h3" textColor="primary-500">
                            {texts.bpm_screen_title.replace(
                                '[X]',
                                allBreadCrumbs[0].title.split(' - ')[0]
                            )}
                        </Title>
                    </div>
                ) : (
                    allBreadCrumbs.map((item, index: number) => {
                        currentWidth = pixelToLetterRatio * item.title.length + currentWidth;
                        if (isBreak && index === 1) {
                            return (
                                <div className="crumb-container" key={index}>
                                    <span className="bread-crumb-dots">...</span>
                                    {this.renderBreadCrumbSeparator()}
                                </div>
                            );
                        } else if (
                            currentWidth < maxWidth ||
                            (isBreak && index === 0) ||
                            index >= breadCrumbsLength - 2
                        ) {
                            return (
                                <div className="crumb-container" key={index}>
                                    {index < allBreadCrumbs.length - 1 ? (
                                        <ModernTooltip
                                            tooltip={item.title}
                                            maxWidth={360}
                                            position="bottom"
                                            wrapperClassname="bread-crumb-tooltip"
                                        >
                                            <span
                                                className="bread-crumb"
                                                key={index}
                                                onClick={e => onBreadcrumbClick(e, item)}
                                            >
                                                {item.title}
                                            </span>
                                            {this.renderBreadCrumbSeparator()}
                                        </ModernTooltip>
                                    ) : (
                                        <div
                                            ref={this.headerTitleRef}
                                            anchor-id="form_header_title"
                                        >
                                            <Title
                                                skin="h3"
                                                textColor="primary-500"
                                                style={{whiteSpace: 'nowrap'}}
                                            >
                                                {item.title}
                                            </Title>
                                        </div>
                                    )}
                                </div>
                            );
                        } else {
                            return <div className="crumb-container" key={index} />;
                        }
                    })
                )}
                {shouldShowAILabel() && (
                    <img src={aiERPlabel} alt="ai-erp-label" className="ai-erp-label" />
                )}
                {getQaMode() === 2 && (
                    <div className="entity-name-crmb" id="entity-name">
                        {formName}
                    </div>
                )}
            </section>
        );
    }
}

export default BreadCrumbs;
